<template>
    <div class="setting identification">
        <van-nav-bar
            title="实名认证"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="identification-box">
            <div class="identification-info flex-space-between">
                <div class="identification-info-left">
                    <p>实名认证成功</p>
                    <p>{{userInfo.name}}</p>
                    <p>{{userInfo.idCardNo}}</p>
                </div>
                <div class="identification-info-right">
                    <div class="info-img">
                        <img src="../../../assets/images/account/userdefault.png" alt="">
                    </div>
                </div>
            </div>
            <div class="setting-item flex-space-between" >
                <p>证件照片</p>
                <div class="setting-item-right" >
                    <p>{{userInfo.idAuthStatus===1?'已上传':'未上传'}}</p>
                </div>
            </div>
            <div class="setting-item flex-space-between">
                <p>人像照片</p>
                <div class="setting-item-right" >
                    <p>{{userInfo.faceAuthStatus===1?'已上传':'未上传'}}</p>
                </div>
            </div>
        </div>
        <div class="identification-footer">
            <van-button plain type="info" @click="show = true" round>解除实名信息绑定</van-button>
        </div>
        <van-dialog className="van-unBoundDialog" v-model="show" title="" getContainer="body" :show-confirm-button="false" width="295px">
            <div class="van-middle">
                <p>请谨慎操作，</p>
                <p>解绑后可重新绑定新用户信息，</p>
                <p>并退出登录，是否解绑？</p>
            </div>
            <div class="van-footer">
                <van-button class="confirm" type="info" round="" @click="confirmUnbound">解除实名信息绑定</van-button>
                <van-button class="cancel" plain type="info" round="" @click="show = false">取消</van-button>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "identification",
    data(){
        return{
            faceShow:false,
            authShow:false,
            userInfo: {},
            show:false
        }
    },
    computed: {
        /* 行业标签
            meet_emergency    应急
        */
		branchIndustry() {
			return this.$store.state.dynamic.pageSetData.branchIndustry
		},
    },
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('WDuserInfo'));
    },
    created(){
        // this.accountProfile();
    },
    methods:{
        onClickLeft() {
            this.$router.go(-1);
        },
        async confirmUnbound(){
            const res = await this.$api.account.cancleAuth()
            if(res.success){
                // 解绑成功后退出登录
                this.logout()
            }
        },
        logout(){
            const params = {
                token: localStorage.getItem("token") || null,
            };
            this.$api.account.logout({ params }).then((res) => {
                if (res.data) {
                    const branchId = localStorage.getItem("branchId");
                    const branchUcode = localStorage.getItem("branchUcode");
                    const saasId = localStorage.getItem("saasId");
                    const frontendConfig = localStorage.getItem('frontendConfig')
                    const sfrontendConfig = sessionStorage.getItem('frontendConfig')
                    localStorage.clear();
                    sessionStorage.clear();
                    this.$store.state.userInfo = {}
                    localStorage.setItem("branchId", branchId);
                    localStorage.setItem("branchUcode", branchUcode);
                    localStorage.setItem("saasId", saasId);
                    localStorage.setItem('frontendConfig', frontendConfig)
                    sessionStorage.setItem('frontendConfig', sfrontendConfig)  
                    // 应急首页、登录定制化配置
                    // 行业标签 meet_emergency    应急
                    if(this.branchIndustry === 'meet_emergency'){
                        this.$router.replace('/yj_training_options');
                    }else{
                        this.$router.replace("/login");
                    }
                } else {
                    this.$toast("退出失败");
                }
            });
        }
    }
}
</script>
<style lang="stylus" scoped>
    .identification {
        position relative
        height calc(100vh - 59px)
    }
    .van-unBoundDialog {
        padding: 32px 24px 24px;
        box-sizing: border-box
        .van-dialog__content {
            .van-middle {
                font-size: 16px;
                color: #202124;
                line-height: 28px;
            }
            .van-footer {
                margin-top 24px
                .van-button {
                    display block
                    width 100%
                    height 40px 
                    margin 0 auto
                    font-size 16px
                    &.confirm {
                        background: linear-gradient(136deg, #227FFF 0%, #316FFF 100%);
                    }
                    &.cancel {
                        margin-top 12px
                        border: 1px solid #3860FF;
                    }
                }
            }
        }
    }
    .identification-footer {
        position absolute
        left 50%
        bottom 0
        transform translateX(-50%)
        .van-button {
            width 345px
            font-size 18px
            color #3860FF
            border-color:  #3860FF;
        }
    }
    .flex-space-between{
        display :flex;
        justify-content:space-between;
        align-items :center;
    }
    .align-items-center{
        display :flex;
        align-items :center;
    }
    .setting{
        .identification-box{
            padding:0 30px;
        }
        .identification-info{
            margin-top:50px;
            height:400px;
            padding:0 50px 0 60px;
            box-sizing :border-box;
            background:url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/account/inbg.png') no-repeat center center;
            background-size:cover;
            .identification-info-right{
                .info-img{
                    width:200px;
                    height:200px;
                    border-radius:50%;
                    box-sizing :border-box;
                    background:url('../../../assets/images/account/avtabg.png') no-repeat;
                    background-position center
                    background-size:cover;
                    text-align center
                    padding-top 18px
                    img{
                        width:160px;
                        height:160px;
                        border-radius:50%;
                    }
                }
            }
            p{
                color:#fff;
                font-size:30px;
                margin-bottom:20px;
                &:nth-child(1){
                    font-size :40px;
                    margin-bottom:30px;
                }
            }
        }
        .setting-item{
            margin-top:30px;
            padding:38px 0;
            border-bottom:1px solid #EAEAEA;
            &:p:nth-child(1){
                padding:20px 0;
            }
            .setting-item-left{
                p{
                    color:#333333;
                    font-size:30px;
                }
            }
            .setting-item-right{
                img{
                    width:100px;
                    height:100px;
                    border-radius:50%;
                }
                p{
                    color:#666;
                    font-size:26px;
                }
            }
        }
    }
</style>